import React, { useEffect } from 'react'
import AOS from 'aos';
import 'aos/dist/aos.css';
import Header from '../Header';
import Footer from '../Footer';

import supportimg from "../../img/icons/support-icon.png"
import commentQuote from "../../img/icons/commont-qute.png"
import detailsimg from "../../img/blog/blog-details-img2.png"
import detailsimg2 from "../../img/blog/blog-details-img3.png"
import detailsimg1 from "../../img/blog/blog-details-img1.png"
import blogdetailimg from "../../img/icons/blog-details-icon1.png"
import blogdetailimg2 from "../../img/icons/blog-details-icon2.png"
import authorImg from "../../img/icons/author.png"
import blogimg3 from "../../img/blog/blog1-image3.png"
import blogimg2 from "../../img/blog/blog1-image2.png"
import blogimg1 from "../../img/blog/blog1-image1.png"
import dateImg from "../../img/icons/date.png"
import aboutpaycoin from "../../img/about/common-hero-coin.png"
import aboutpaycoin2 from "../../img/about/about-hero-area.png"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleLeft, faAngleRight, faArrowRight, faCheck, faChevronLeft, faChevronRight, faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore from 'swiper';
import { Autoplay, Navigation } from 'swiper/modules';
import { useNavigate } from 'react-router-dom';
import { faFacebookF, faGooglePlusG, faLinkedinIn, faYoutube } from '@fortawesome/free-brands-svg-icons';



SwiperCore.use([Navigation, Autoplay]);

const BlogDetailRight = () => {

    return (
        <>
            <Header />
            <div class="common-hero" style={{ backgroundImage: `url(${require('../../img/bg/common-hero-bg.png')})` }}>
                <div class="container">
                    <div class="row align-items-center">
                        <div class="col-lg-5">
                            <div class="main-heading">
                                <h1>Blog Details</h1>
                                <div class="space16"></div>
                                <p>Investing in cryptocurrenciesan be exciting journey, but it's essential to approach it with caution and diligence.</p>
                                <div class="subscribe-form">
                                    <form action="#">
                                        <input type="email" placeholder="Email Address" />
                                        <div class="button">
                                            <button class="theme-btn1 btn btn--ripple ripple">Get Started <FontAwesomeIcon icon={faArrowRight} transform={{ rotate: 315 }} style={{ marginLeft: "5px" }} /></button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-7">
                            <div class="common-hero-images">
                                <div class="image1">
                                    <img src={aboutpaycoin} alt="" />
                                </div>

                                <div class="image2">
                                    <img src={aboutpaycoin2} alt="" />
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="blog-details-area sp">
                <div class="container">
                    <div class="row">

                        <div class="col-lg-8">
                            <div class="blog-details-posts left">
                                <article>
                                    <div class="details-post-single">
                                        <div class="image image-anime">
                                            <img src={detailsimg1} alt="" />
                                        </div>
                                        <div class="athor-users">
                                            <ul>
                                                <li><a href="#" class="tag">#Blockchain Crypto</a></li>
                                                <li><a href="#" class="date"><img src={blogdetailimg} alt="" /> 10 October 2023</a></li>
                                                <li><a href="#" class="date"><img src={blogdetailimg2} alt="" /> 2 Comments</a></li>
                                            </ul>
                                        </div>
                                        <div class="heading1">
                                            <h2>The Power Of Diversification In Cryptocurrency On Investment</h2>
                                            <div class="space20"></div>
                                            <p>At PayCoin, we understand that you may have questions about using our platform, and we're here to provide you with the answers you need. Below, you'll find a selection of frequently asked questions to help you navigate the world of cryptocurrency trading with ease. From account security to deposit and withdrawal processes, we cover.</p>
                                            <div class="space20"></div>
                                            <p>Transparency and clarity are fundamental values at PayCoin, which is why we compiled this comprehensive list of frequently asked questions to address any concerns you may have. Whether you're a novice trader or an experienced investor, our goal is to provide.</p>
                                        </div>
                                    </div>
                                </article>
                                <div class="details-border"></div>
                                <article>
                                    <div class="details-post-single">
                                        <div class="row">
                                            <div class="col-md-6">
                                                <div class="image image-anime">
                                                    <img src={detailsimg} alt="" />
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="image image-anime">
                                                    <img src={detailsimg2} alt="" />
                                                </div>
                                            </div>
                                        </div>
                                        <div class="space20"></div>
                                        <div class="heading1">
                                            <h3>Discover Future of Finance with PayCoin</h3>
                                            <div class="space16"></div>
                                            <p>Whether you're a seasoned trader or just starting out, our platform offers the tools, best cresources, and support you need to succeed in the dynamic world of cryptocurrency trading. With our user-friendly interface, robust security measures, & comprehensive</p>
                                        </div>

                                        <div class="space30"></div>
                                        <div class="row">
                                            <div class="col-md-6">
                                                <ul class="list">
                                                    <li><span class="check"><FontAwesomeIcon icon={faCheck} /></span> Secure And Trading Platform</li>
                                                    <li><span class="check"><FontAwesomeIcon icon={faCheck} /></span> Wide Range of Cryptocurrency</li>
                                                    <li><span class="check"><FontAwesomeIcon icon={faCheck} /></span> Fast and Efficient Transactions</li>
                                                </ul>
                                            </div>

                                            <div class="col-md-6">
                                                <ul class="list">
                                                    <li><span class="check"><FontAwesomeIcon icon={faCheck} /></span> Secure And Trading Platform</li>
                                                    <li><span class="check"><FontAwesomeIcon icon={faCheck} /></span> Wide Range of Cryptocurrency</li>
                                                    <li><span class="check"><FontAwesomeIcon icon={faCheck} /></span> Fast and Efficient Transactions</li>
                                                </ul>
                                            </div>

                                        </div>
                                    </div>
                                </article>

                                <div class="details-border"></div>

                                <div class="heading1">
                                    <h3>Trade Cryptocurrency a Pro with PayCoin</h3>
                                    <div class="space16"></div>
                                    <p>"Experience the ultimate in cryptocurrency trading with PayCoin. Our platform offers a comprehensive suite of benefits designed to elevate your trading experience to new heights. Trade with confidence on our secure and reliable platform, backed by state.</p>

                                </div>
                                <div class="space30"></div>
                                <div class="commnet-box">
                                    <p>“Blockchain technology represents the second era the internet - a new paradigm for how information is shared, value is transferred, and trust is established shift in the way we perceive & interact”</p>
                                    <img src={commentQuote} alt="" class="qute" />
                                </div>

                                <div class="details-border"></div>

                                <div class="social-area">
                                    <div class="athor-users">
                                        <ul>
                                            <li><a href="#" class="tag">#Blockchain Crypto</a></li>
                                        </ul>
                                    </div>
                                    <div class="icons">
                                        <ul>
                                            <li class="text">Share:</li>
                                            <li><a href="#"><FontAwesomeIcon icon={faFacebookF} /></a></li>
                                            <li><a href="#"><FontAwesomeIcon icon={faGooglePlusG} /></a></li>
                                            <li><a href="#"><FontAwesomeIcon icon={faLinkedinIn} /></a></li>
                                            <li><a href="#"><FontAwesomeIcon icon={faYoutube} /></a></li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="space30"></div>
                                <div class="support-box">
                                    <div class="icon">
                                        <img src={supportimg} alt="" />
                                    </div>
                                    <div class="pera">
                                        <p>Questions? Comments? Visit Our Help Center For Support</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-4">
                            <div class="side-all">
                                <div class="details-sidebox">
                                    <h3>Search</h3>
                                    <div class="search-area">
                                        <form action="#">
                                            <input type="search" placeholder="Search..." />
                                            <div class="button">
                                                <button type="submit"><FontAwesomeIcon icon={faMagnifyingGlass} /></button>
                                            </div>
                                        </form>
                                    </div>
                                </div>

                                <div class="details-sidebox">
                                    <h3>Recent Post</h3>
                                    <div class="recent-post">
                                        <ul>
                                            <li><a href="/blogDetail" class="active">The Best Ultimate Crypto Trading Handbook: Strategies, Tips More</a></li>
                                            <li><a href="/blogDetail">The Best Ultimate Crypto Trading Handbook: Strategies, Tips More</a></li>
                                            <li><a href="/blogDetail">The Power of Diversification in Cryptocurrency on Investment</a></li>
                                            <li><a href="/blogDetail">The Future of Finance: Exploring the World Best Cryptocurrency</a></li>
                                            <li><a href="/blogDetail">Exclusive Analysis & Commentary on the Cryptocurrency Market</a></li>
                                        </ul>
                                    </div>
                                </div>

                                <div class="details-sidebox">
                                    <h3>Popular Tags</h3>
                                    <div class="tags">
                                        <ul>
                                            <li><a href="#">#Cryptocurrency</a></li>
                                            <li><a href="#" class="active">#CryptoNews</a></li>
                                            <li><a href="#">#Finance</a></li>
                                            <li><a href="#">#CryptocurrencyMarket</a></li>
                                            <li><a href="#">Blockchain</a></li>
                                            <li><a href="#">Bitcoin</a></li>
                                            <li><a href="#">Investing</a></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <div class="blog1 sp">
                <div class="container">
                    <div class="row">
                        <div class="col-lg-6 m-auto text-center">
                            <div class="heading1">
                                <span class="span">Our Blog</span>
                                <h2>Latest Blog & News</h2>
                            </div>
                        </div>
                    </div>

                    <div class="space30"></div>
                    <div class="row">
                        <div class="col-lg-4 col-md-6">
                            <div class="blog-box">
                                <div class="image img100 image-anime">
                                    <img src={blogimg1} alt="" />
                                </div>
                                <div class="tags">
                                    <a href="#"><img src={authorImg} alt="" /> Alex Robertson</a>
                                    <a href="#"><img src={dateImg} alt="" /> 7/31/2023</a>
                                </div>
                                <div class="heading1">
                                    <h5><a href="/blogDetail">The Power of Diversification in Cryptocurrency on Investment</a></h5>
                                    <div class="space16"></div>
                                    <p>In today's dynamic financial landscape, a cryptocurrency trading has emerged as.</p>
                                    <div class="space16"></div>
                                    <a href="/blogDetail" class="learn">Read More <span><i class="fa-solid fa-arrow-right"></i></span></a>
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-4 col-md-6">
                            <div class="blog-box">
                                <div class="image img100 image-anime">
                                    <img src={blogimg2} alt="" />
                                </div>
                                <div class="tags">
                                    <a href="#"><img src={authorImg} alt="" /> Alex Robertson</a>
                                    <a href="#"><img src={dateImg} alt="" /> 7/31/2023</a>
                                </div>
                                <div class="heading1">
                                    <h5><a href="/blogDetail">The Best Ultimate Crypto Trading Handbook: Strategies, Tips More</a></h5>
                                    <div class="space16"></div>
                                    <p>In today's dynamic financial landscape, a cryptocurrency trading has emerged as.</p>
                                    <div class="space16"></div>
                                    <a href="/blogDetail" class="learn">Read More <span><i class="fa-solid fa-arrow-right"></i></span></a>
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-4 col-md-6">
                            <div class="blog-box">
                                <div class="image img100 image-anime">
                                    <img src={blogimg3} alt="" />
                                </div>
                                <div class="tags">
                                    <a href="#"><img src={authorImg} alt="" /> Alex Robertson</a>
                                    <a href="#"><img src={dateImg} alt="" /> 7/31/2023</a>
                                </div>
                                <div class="heading1">
                                    <h5><a href="/blogDetail">The Benefits of Diversification in Cryptocurrency Investment</a></h5>
                                    <div class="space16"></div>
                                    <p>In today's dynamic financial landscape, a cryptocurrency trading has emerged as.</p>
                                    <div class="space16"></div>
                                    <a href="/blogDetail" class="learn">Read More <span><i class="fa-solid fa-arrow-right"></i></span></a>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
}

export default BlogDetailRight;